import React from 'react'
import { FormSpy as FormSpyComponent, FormSpyProps } from 'react-final-form'

const FormSpy = (props: FormSpyProps): React.ReactElement => {
  return <FormSpyComponent {...props} />
}

export default FormSpy
